import { render, staticRenderFns } from "./admin-result.vue?vue&type=template&id=4727bffe&scoped=true"
import script from "./admin-result.vue?vue&type=script&lang=js"
export * from "./admin-result.vue?vue&type=script&lang=js"
import style0 from "./admin-result.vue?vue&type=style&index=0&id=4727bffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4727bffe",
  null
  
)

export default component.exports